import { render, staticRenderFns } from "./SectionTwo.vue?vue&type=template&id=6a67e2fc"
import script from "./SectionTwo.vue?vue&type=script&lang=js"
export * from "./SectionTwo.vue?vue&type=script&lang=js"
import style0 from "./SectionTwo.vue?vue&type=style&index=0&id=6a67e2fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports